import { L, vocabulary } from '../define.js';
/** D577 slice d: alerts-booking-status. */
export const ALERTS_BOOKING_STATUS_VOCABULARIES = [
    vocabulary('alerts.alert_recipient', '@vello/alerts ALERT_RECIPIENTS', {
        PLATFORM: L('Equipe da plataforma', 'Platform team', 'Equipo de la plataforma', 'Team della piattaforma'),
        DRIVER: L('Motoristas', 'Drivers', 'Conductores', 'Autisti'),
        RIDER: L('Passageiros', 'Riders', 'Pasajeros', 'Passeggeri'),
    }),
    // typed locally: the source cannot be imported here (cycle) or is not exported
    vocabulary('alerts.amount_field', '@vello/alerts AMOUNT_FIELD', {
        HIGH_ESTIMATED_FARE: L('Tarifa estimada alta', 'High estimated fare', 'Tarifa estimada alta', 'Tariffa stimata alta'),
        HIGH_FINAL_FARE: L('Tarifa final alta', 'High final fare', 'Tarifa final alta', 'Tariffa finale alta'),
        RIDER_BALANCE_ABOVE_LIMIT: L('Saldo devedor do passageiro acima do limite', 'Rider balance above the limit', 'Saldo del pasajero por encima del límite', 'Saldo del passeggero sopra il limite'),
    }),
    vocabulary('operator_booking.action', '@vello/operator-booking OperatorAction', {
        create: L('Criar', 'Create', 'Crear', 'Creare'),
        schedule: L('Agendar', 'Schedule', 'Programar', 'Programmare'),
        direct: L('Atribuir diretamente', 'Assign directly', 'Asignar directamente', 'Assegnare direttamente'),
        cancel: L('Cancelar', 'Cancel', 'Cancelar', 'Annullare'),
    }),
    vocabulary('operator_booking.state', '@vello/operator-booking BookingState', {
        created: L('Criada', 'Created', 'Creada', 'Creata'),
        scheduled: L('Agendada', 'Scheduled', 'Programada', 'Programmata'),
    }),
    vocabulary('customer_360.purpose', '@vello/customer-360 PURPOSES', {
        trip_support: L('Atendimento de corrida', 'Trip support', 'Atención de viaje', 'Assistenza corsa'),
        payment_dispute: L('Contestação de pagamento', 'Payment dispute', 'Disputa de pago', 'Contestazione di pagamento'),
        safety_incident: L('Ocorrência de segurança', 'Safety incident', 'Incidente de seguridad', 'Incidente di sicurezza'),
        account_help: L('Ajuda com a conta', 'Account help', 'Ayuda con la cuenta', 'Aiuto con l’account'),
    }),
    vocabulary('status_page.incident_state', '@vello/status-automation IncidentState', {
        investigating: L('Investigando', 'Investigating', 'Investigando', 'In analisi'),
        identified: L('Causa identificada', 'Cause identified', 'Causa identificada', 'Causa individuata'),
        monitoring: L('Monitorando', 'Monitoring', 'Monitoreando', 'In monitoraggio'),
        resolved: L('Resolvido', 'Resolved', 'Resuelto', 'Risolto'),
    }),
];
//# sourceMappingURL=alerts-booking-status.js.map